import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { Container } from '../components/Container';
import { ChecklistMock } from '../components/mockups/ChecklistMock';
const ease = [0.16, 1, 0.3, 1] as const;
export function Hero() {
  const reduced = useReducedMotion();
  return <section className="relative overflow-hidden pt-28 pb-16 sm:pt-44 sm:pb-24" data-id="element-776">
      <div className="pointer-events-none absolute inset-0 hero-glow" data-id="element-777" />
      <div className="pointer-events-none absolute inset-0 dot-grid opacity-40 [mask-image:radial-gradient(ellipse_at_center,black_25%,transparent_70%)]" data-id="element-778" />

      <Container className="relative" data-id="element-779">
        <motion.h1 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.75,
        delay: 0.12,
        ease
      }} className="display-tighten text-balance mx-auto max-w-4xl text-center font-serif-display text-[3rem] leading-[1.0] text-white sm:text-7xl sm:leading-[0.95] lg:text-[5.75rem]" data-id="element-780">
          <span className="italic text-accent" data-id="element-781">Automate</span>
          <br className="sm:hidden" data-id="element-782" />
          <span className="hidden sm:inline" data-id="element-783"> </span>
          follow-ups
          <br data-id="element-784" />
          and paper chasing.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.24,
        ease
      }} className="measure mx-auto mt-5 px-2 text-center text-[15px] leading-relaxed text-zinc-400 sm:mt-7 sm:px-0 sm:text-lg" data-id="element-785">
          Automate subjectivities, premium audits, inspections, renewals, and
          more.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.32,
        ease
      }} className="mt-8 flex flex-col items-center justify-center gap-3 sm:mt-10 sm:flex-row" data-id="element-786">
          <a href="https://calendly.com/pigeondocuments" target="_blank" rel="noopener noreferrer" className="btn-accent btn-accent-lg group" data-id="element-787">
            Book a Call
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" data-id="element-788" />
          </a>
        </motion.div>

        {/* Single artifact: the self-completing checklist */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.45,
        ease
      }} className="relative mx-auto mt-12 max-w-md px-2 sm:mt-20 sm:max-w-lg sm:px-0" data-id="element-789">
          {/* Atmospheric aura — pulled back, less product-demo */}
          <motion.div aria-hidden initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1.6,
          delay: 0.4,
          ease
        }} className="pointer-events-none absolute left-1/2 top-1/2 h-[150%] w-[130%] -translate-x-1/2 -translate-y-1/2" data-id="element-790">
            <motion.div animate={reduced ? undefined : {
            scale: [1, 1.04, 1],
            opacity: [0.5, 0.75, 0.5]
          }} transition={{
            duration: 12,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="absolute left-1/2 top-1/2 h-[80%] w-[80%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(circle_at_center,rgba(56,189,248,0.22),rgba(99,102,241,0.08)_50%,transparent_72%)] blur-[110px]" data-id="element-791" />
            <motion.div animate={reduced ? undefined : {
            scale: [1.02, 0.98, 1.02],
            opacity: [0.45, 0.7, 0.45]
          }} transition={{
            duration: 10,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="absolute left-1/2 top-1/2 h-[65%] w-[55%] -translate-x-1/2 -translate-y-1/2 rounded-[3rem] bg-accent/15 blur-[90px]" data-id="element-792" />
          </motion.div>

          {/* Floating mock — refined hairline rim */}
          <motion.div animate={reduced ? undefined : {
          y: [0, -3, 0]
        }} transition={{
          duration: 9,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="relative" data-id="element-793">
            <div aria-hidden className="pointer-events-none absolute -inset-px rounded-xl bg-gradient-to-b from-white/[0.12] via-white/[0.04] to-transparent" data-id="element-794" />
            <div className="relative" data-id="element-795">
              <ChecklistMock data-id="element-796" />
            </div>
          </motion.div>
        </motion.div>
      </Container>
    </section>;
}